// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".social-post{background-color:#fff;position:relative;margin:0 15px}@media(min-width:768px){.social-post{padding-left:1.5rem;padding-right:1.5rem;margin-left:-1.5rem;margin-right:-1.5rem}}.social-post .social-image{height:auto}.social-post .post-body h2{margin-bottom:2rem}.social-post .post-body h2:not(:first-of-type){margin-top:3rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
